import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from './Button';
import { authenticationService } from '../../services';

export default function LoginButton(props: { redirectTo?: string }): JSX.Element {
  const { t } = useTranslation();
  const [params] = useSearchParams();

  const navigate = useNavigate();
  const link = params.get('link');
  const { redirectTo } = props;

  function removeQueryParam(url: string, paramToRemove: string): string {
    const [path, query] = url.split('?');

    if (!query) return url;

    const paramsInString = new URLSearchParams(query);
    paramsInString.delete(paramToRemove);

    const newQuery = paramsInString.toString();
    return newQuery ? `${path}?${newQuery}` : path;
  }

  const loginMagic = useCallback(() => {
    authenticationService
      .loginMagic(link || '')
      .then(() => {
        if (redirectTo) {
          navigate(redirectTo);
        }
      })
      .catch(() => {
        toast.error(t('toast.error.login'));
        if (redirectTo) {
          const cleanedLink = removeQueryParam(redirectTo, 'link');
          navigate(cleanedLink);
        }
      });
  }, [authenticationService, link, redirectTo]);

  return (
    <div className="flex flex-col items-center gap-2">
      {typeof window !== 'undefined' &&
        ((window.matchMedia && window.matchMedia('(max-width: 640px)').matches) ||
          /Mobi|Android/i.test(navigator.userAgent)) && (
          <p className="text-base">{t('page.magicLogin.mobileContent')}</p>
        )}
      <Button variant="primary" onClick={loginMagic}>
        <span className="inline whitespace-nowrap">{t('general.continue')}</span>
      </Button>
    </div>
  );
}
